import { session } from "./session";

export type ConferenceInfo = {
    Id: string;
    Name: string;
    Address1: string;
    Address2: string;
    City: string;
    State: string;
    Zip: string;
    Email: string;
    Phone: string;
    LocationHeader: string;
    MiscInfo: string;
    Description: string;
    Image: string;
    MissionStatement: string;
    StaffDescription: string;
    Privacy: string
    CoC : string;
    Keynotes: session[];
    CurrentEventId: string;
};

export function newConferenceInfo():ConferenceInfo{
    return {
        Id:"",
        Name: "",
        Address1: "",
        Address2: "",
        City: "",
        State: "",
        Zip: "",
        Email: "",
        Phone: "",
        LocationHeader: "",
        MiscInfo: "",
        Description: "",
        Image: "",
        MissionStatement: "",
        StaffDescription: "",
        Privacy: "",
        CoC: "",
        Keynotes:[],
        CurrentEventId: ""
    };
};
export interface ConferenceInfoProps {
    conference: ConferenceInfo|undefined;
    saveContent: (content:string)=>void;
  };